<div class="dialog-container">
  <h2 mat-dialog-title>Submit Script</h2>
  
  <mat-dialog-content>
    <div class="dialog-description">
      Add a comment for the review team (optional). This will help them understand your script better.
    </div>
    <mat-form-field appearance="outline" style="width: 100%;">
      <mat-label>Author Comment (optional)</mat-label>
      <textarea 
      matInput 
      formControlName="authorComment" 
      rows="4">
    </textarea>
    @if (form.get('authorComment')?.hasError('maxlength')) {
      <mat-error>
        Comment must be less than 1000 characters
      </mat-error>
    }
    <mat-hint>{{form.get('authorComment')?.value?.length || 0}}/1000 characters</mat-hint>
  </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button type="button" (click)="onCancel()">Cancel</button>
  <button mat-flat-button type="submit" [disabled]="!form.valid" cdkFocusInitial (click)="onSubmit()">
    Submit Script
  </button>
</mat-dialog-actions>
</div>
